import { CmsMeta } from '../cmsMeta';
import './CmsKpi.css';

type CmsKpiProps = {
	value: string;
	label: string;
	note?: string;
	size?: 'md' | 'lg';
};

/** One figure, large, with what it counts under it - a rating, a number of customers, a delivery time. */
export const CmsKpi = ({ value, label, note, size }: CmsKpiProps): JSX.Element => (
	// content is json nobody type-checked, and a size with no rule would print the figure at body size
	<div className={`cms-kpi cms-kpi--${size === 'md' ? 'md' : 'lg'}`}>
		<span className="cms-kpi__value">{value}</span>
		<span className="cms-kpi__label">{label}</span>
		{note && <span className="cms-kpi__note">{note}</span>}
	</div>
);

export const cmsMeta: CmsMeta = {
	description:
		'One figure, large, with what it counts under it - a rating, a number of customers, a delivery time. `value` is the figure as it should read, written the way the market writes numbers; `label` says what it is; `note` is an optional smaller line, such as where a rating comes from. `size` is md or lg. Write only figures somebody can stand behind: read them off the facts tool or a published page, never from memory.',
	example: ['CmsKpi', { value: '700 000+', label: 'kunder', note: 'i fem europeiska marknader', size: 'lg' }],
};
